import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { staticDataTypeQueries } from '@/services/staticDataType/staticDataType.queries';

export const useStaticDataTypeDetail = (staticDataTypeId?: string) => {
  const { data, isLoading } = useQuery({
    ...staticDataTypeQueries.details(staticDataTypeId ?? ''),
    enabled: Boolean(staticDataTypeId),
  });

  return { staticData: data?.data, isLoading };
};
